import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Dropdown } from 'semantic-ui-react';

const CLOSE_DELAY_MS = 50;

const triggerStyle = {
  minWidth: '180px',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export default class InlineFilterDropdown extends Component {
  state = { open: false, searchQuery: '' };

  componentWillUnmount() {
    clearTimeout(this.closeTimer);
  }

  openNow = () => {
    clearTimeout(this.closeTimer);
    if (!this.state.open) this.setState({ open: true });
  };

  scheduleClose = () => {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.setState({ open: false }), CLOSE_DELAY_MS);
  };

  closeNow = () => {
    clearTimeout(this.closeTimer);
    this.setState({ open: false });
  };

  onChange = (event, { value }) => {
    const { filter, onChange } = this.props;
    this.setState({ searchQuery: '' });
    if (filter.onSearch) filter.onSearch('');
    onChange(filter.field, value || undefined);
    this.closeNow();
  };

  onSearchChange = (event, { searchQuery }) => {
    const { filter } = this.props;
    this.setState({ searchQuery });
    if (filter.onSearch) filter.onSearch(searchQuery);
  };

  render() {
    const { filter: f } = this.props;
    const { open, searchQuery } = this.state;
    const prefix = [];
    if (f.value) {
      prefix.push({ key: '__clear', value: '', text: `Clear ${f.label.toLowerCase()}` });
    }
    if (f.suggestionsLabel && !_.isEmpty(f.options)) {
      prefix.push({
        key: '__suggestions-header',
        text: f.suggestionsLabel,
        disabled: true,
        className: 'header',
      });
    }
    const options = [...prefix, ...f.options];
    const asyncSearch = !!f.onSearch;
    return (
      <Dropdown
        item
        search={asyncSearch ? opts => opts : true}
        open={open}
        onOpen={this.openNow}
        onClose={this.closeNow}
        onMouseEnter={this.openNow}
        onMouseLeave={this.scheduleClose}
        selectOnBlur={false}
        allowAdditions={!!f.allowAdditions}
        additionLabel={f.allowAdditions ? 'Use: ' : undefined}
        options={options}
        value={f.value || ''}
        searchQuery={searchQuery}
        onChange={this.onChange}
        onSearchChange={this.onSearchChange}
        loading={!!f.isSearching}
        noResultsMessage={f.noResultsMessage}
        placeholder={f.searchPlaceholder}
        text={
          f.value
            ? <span>{f.label}: <strong>{f.value}</strong></span>
            : (f.emptyLabel || f.label)
        }
        style={triggerStyle}
      />
    );
  }
}

InlineFilterDropdown.propTypes = {
  filter: PropTypes.shape({
    field: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    emptyLabel: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.string,
    allowAdditions: PropTypes.bool,
    suggestionsLabel: PropTypes.string,
    onSearch: PropTypes.func,
    isSearching: PropTypes.bool,
    noResultsMessage: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/components/inline-filter-dropdown/index.js
 **/